var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border border-gray-400 lg:flex rounded overflow-hidden bg-white p-2"},[_c('div',{staticClass:"flex w-full",class:_vm.horizontal ? 'flex-row' : 'flex-col'},[_vm._t("header"),_vm._t("default"),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }